// extracted by mini-css-extract-plugin
export var contact = "index-module--contact--los+K";
export var image = "index-module--image--CqXv6";
export var inputField = "index-module--inputField--qlti-";
export var submitBtn = "index-module--submitBtn--+tpcr";
export var successMessage = "index-module--successMessage--quGCi";